import ItemList from 'items/ItemList'
import NewItem from 'items/NewItem'
import EditItem from 'items/EditItem'
import Overview from './Overview'

export const RouteConfig = [
  {
    path: '/items',
    component: ItemList,
  },
  {
    path: '/items/new',
    component: NewItem,
  },
  {
    path: '/items/:id/edit',
    component: EditItem,
  },
  {
    path: '/overview',
    component: Overview,
  },
]
